import React, { FC, useEffect, useState } from 'react';
import {
  Container,
  Grid,
  IconButton,
  Link,
  makeStyles,
  Slide,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { fade } from '@material-ui/core/styles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import CloseIcon from '@material-ui/icons/Close';
import { useQueryClient } from 'react-query';

import { useCurrentUser, useNotify } from 'hooks';
import { useUpdateUserProfileMutation, useGetUserSocialConnectionsQuery } from 'api';

const useStyles = makeStyles(theme => ({
  background: {
    width: '100%',
    backgroundColor: fade(theme.palette.primary.main, 0.1),
    padding: theme.spacing(1, 0),
  },
  text: {
    cursor: 'pointer',
  },
  closeIcon: {
    position: 'absolute',
    right: 15,
  },
  timeIcon: {
    display: 'block',
  },
}));

const SmartSchedulerBanner: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const notify = useNotify();
  const { id, smart_schedule_acknowledgement, smart_schedule_viewed } = useCurrentUser();
  const queryClient = useQueryClient();

  const [render, setRender] = useState(!smart_schedule_viewed);

  useEffect(() => {
    !smart_schedule_acknowledgement &&
      updateUserProfile({
        data: { id, smart_schedule_acknowledgement: true },
      });
  }, []);

  const { mutate: updateUserProfile } = useUpdateUserProfileMutation({
    onSuccess: data => {
      if (!data.updateUserProfile.smart_schedule_viewed) {
        setRender(true);
      }

      void queryClient.refetchQueries(useGetUserSocialConnectionsQuery.getKey({ user_id: id }));
    },
    onError: notify.mutationError,
  });

  function onClickCancel() {
    setRender(false);
    updateUserProfile({
      data: { id, smart_schedule_viewed: true },
    });
  }

  if (!render) {
    return null;
  }

  return (
    <Slide in mountOnEnter unmountOnExit>
      <Toolbar disableGutters variant="dense">
        <Grid className={classes.background}>
          <Container>
            <Grid container direction="row" alignItems="center" justify="center" spacing={1}>
              <Grid item>
                <AccessTimeIcon color="primary" className={classes.timeIcon} />
              </Grid>

              <Grid item>
                <Typography color="primary" variant="subtitle2">
                  {t('components:smartSchedulerMessage')}
                </Typography>
              </Grid>

              <Grid item>
                <Link
                  underline="always"
                  color="primary"
                  href="https://help.everyonesocial.app/hc/en-us/articles/8531065142807"
                  target="_blank"
                >
                  <Typography color="primary" variant="subtitle2" className={classes.text}>
                    {t('components:learnMore')}
                  </Typography>
                </Link>
              </Grid>

              <IconButton onClick={onClickCancel} className={classes.closeIcon}>
                <CloseIcon color="primary" />
              </IconButton>
            </Grid>
          </Container>
        </Grid>
      </Toolbar>
    </Slide>
  );
};

export default SmartSchedulerBanner;
